// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__7G9x6","label":"Completed_label__2lSES"};